'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { NoActivePriceListsBanner } from 'src/app/(main)/_components/no-active-price-lists-banner'
import { useGetStocklistSourceNames } from 'src/deprecated/hooks/api/useGetStocklistSourceNames'

export function NoActivePriceListsBannerWrapper() {
  const { totalResults, isSuccess } = useGetStocklistSourceNames({
    filterExpired: true,
  })

  if (!isSuccess) {
    return null
  }

  return <NoActivePriceListsBanner hasActivePriceLists={totalResults > 0} />
}
